import { useEffect, useState } from "react";
import api from "../../services/api";

interface CategoryCounterProps {
  onUpdate?: (count: number) => void;
}

export default function CategoryCounter({ onUpdate }: CategoryCounterProps) {
  const [count, setCount] = useState<number | null>(null);

  useEffect(() => {
    api.get("/categories")
      .then(res => {
        const c = Array.isArray(res.data) ? res.data.length : 0;
        setCount(c);
        if (onUpdate) onUpdate(c);
      })
      .catch(() => setCount(0));
  }, [onUpdate]);

  return (
    <div className="text-6xl font-black text-on-surface tracking-tighter">
      {count !== null ? count : "..."}
    </div>
  );
}
